import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '@blaze-shared/shared-feature';

import { FormBuilderComponent } from './form-builder/form-builder.component';

@NgModule({
  imports: [CommonModule, FormBuilderComponent, FormsModule, ReactiveFormsModule, SharedModule],
})
export class FormBuilderModule {}
